/* GameEditorActionableIcon.js */

'use strict';
const ActionableIcon = require('@gluenetworks/steve_ui_core').IconTypes['actionable-icon-gl'];

class GameEditorActionableIcon extends ActionableIcon {
  // createdCallback(){
  //     super.createdCallback(arguments);
  // }
  // attachedCallback(){
  //     super.attachedCallback(arguments);
  // }
  // attributeChangedCallback(/*attrName, oldVal, newVal*/){
  //     super.attributeChangedCallback(arguments);
  // }
  // detachedCallback(){
  //     super.detachedCallback(arguments);
  // }
}

let icon,
  customElementRegistry = window.customElements;

if (customElementRegistry) {
  icon = customElementRegistry.get('game-editor-actionable-icon-gl');
  if (!icon) {
    customElementRegistry.define('game-editor-actionable-icon-gl', GameEditorActionableIcon);
    icon = customElementRegistry.get('game-editor-actionable-icon-gl');
  }
} else if (document.registerElement) {
  icon = document.registerElement('game-editor-actionable-icon-gl', GameEditorActionableIcon);
} else {
  icon = GameEditorActionableIcon;
}

module.exports = icon;
